import React, { useState, useEffect, useRef } from "react";
import { Nav, Tab } from "react-bootstrap";
import "./Menu_bar_header.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  getAllChildCategory,
  getAllSubCategory,
  getSubCategory,
} from "../../../features/master/masterSlice";

function Menu_bar_header({}) {
  const [activeMenu, setActiveMenu] = useState(false);
  const [activeMenuCategory, setActiveMenuCategory] = useState(false);
  const menuRef = useRef(null);


  const menuItems = [
    { name: "View All" },
    { name: "Visiting Cards" },
    { name: "Calendars & Diaries" },
    { name: "Stationery" },
    { name: "Corporate Gifts" },
    { name: "Labels & Packaging Apparel" },
    { name: "Signages" },
    { name: "Marketing & Promo Photo Gifts" },
  ];

  const menuContent = {
    "View All": [
      { title: "Business Essentials", items: ["Item 1", "Item 2", "Item 3"] },
      {
        title: "Premium Business Cards",
        items: ["Premium Laminated Cards", "Eco-Friendly Business Cards"],
      },
      {
        title: "Standard Business Cards",
        items: ["Textured Cards", "Spot UV Cards"],
      },
    ],
    "Visiting Cards": [
      { title: "Business Essentials", items: ["Item A", "Item B"] },
      {
        title: "Premium Business Cards",
        items: ["Textured Cards", "Spot UV Cards"],
      },
    ],
    "Calendars & Diaries": [
      { title: "2025 Calendars", items: ["Wall Calendar", "Desk Calendar"] },
      { title: "Diaries", items: ["Leather Diaries", "Custom Diaries"] },
    ],
    Stationery: [
      { title: "Pens", items: ["Ballpoint Pen", "Fountain Pen"] },
      { title: "Notebooks", items: ["Spiral Notebook", "Hardcover Notebook"] },
    ],
    "Corporate Gifts": [
      { title: "Gift Sets", items: ["Custom Mugs", "Branded T-shirts"] },
      { title: "Branded Apparel", items: ["T-shirts", "Hoodies"] },
    ],
    "Labels & Packaging Apparel": [
      { title: "Labels", items: ["Custom Labels", "Roll Labels"] },
      { title: "Packaging", items: ["Packaging Boxes", "Tote Bags"] },
    ],
    Signages: [
      { title: "Office Signages", items: ["Door Signs", "Wall Signs"] },
      { title: "Outdoor Banners", items: ["Custom Banners", "Vinyl Banners"] },
    ],
    "Marketing & Promo Photo Gifts": [
      { title: "Photo Frames", items: ["Wooden Frames", "Acrylic Frames"] },
      { title: "Custom Mugs", items: ["Ceramic Mugs", "Travel Mugs"] },
    ],
  };
  const dispatch = useDispatch();
  const handleClickOutside = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      !event.target.closest(".dropdown_menu_holder")
    ) {
      setActiveMenu(false);
      setActiveMenuCategory(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  const category = useSelector((state) => state.master.categories);
  const subcategory = useSelector((state) => state.master.subcategories);
  const childcategory = useSelector((state) => state.master.childcategories);
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);
  const [activeCategory, setActiveCategory] = useState(category[0]?.id || "");
  const [activeSubCategory, setActiveSubCategory] = useState();

  const handleCategoryChange = (categoryId) => {
    setActiveCategory(categoryId);
    dispatch(getAllSubCategory(categoryId));
    // setActiveMenuCategory(true);
  };

  const handleSubCategoryChange = (subCategoryId) => {
    setActiveSubCategory(subCategoryId);
    dispatch(getAllChildCategory(subCategoryId));
  };

  // Fetch categories only once when the component mounts

  useEffect(() => {
    dispatch(getAllSubCategory(category[0]?.id));
    // setActiveSubCategory(subcategory[0]?.id);
  }, [dispatch, category[0]?.id]);

  useEffect(() => {
    if (category?.length > 0) {
      setActiveCategory(category[0].id);
    }
  }, [category]);

  useEffect(() => {
    if (subcategory?.length > 0) {
      setActiveSubCategory(subcategory[0].id);
      dispatch(getAllChildCategory(subcategory[0].id));
    } else {
      // If there are no subcategories, keep the previous state and do nothing.
      setActiveSubCategory(null);
    }
  }, [subcategory]);

  return (
    <>
      <section className="Menu_bar_header">
        <div className="custom_container">
          <div className="menu_holder" ref={menuRef}>
            <Nav.Link
              // key={index}
              href="#"
              // onClick={(e) => {
              //   e.preventDefault();
              //   setActiveMenu(activeMenu === item.name ? null : item.name);
              // }}
              onClick={(e) => {
                e.preventDefault();
                setActiveMenuCategory(false);
                setActiveMenu(true);
                // handleCategoryChange(item.id)
              }}
            >
              View All
            </Nav.Link>
            {category?.map((item, index) => (
              <Nav.Link
                key={index}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveMenuCategory(true);
                  handleCategoryChange(item.id);

                  if (item.subcategory?.length > 0) {
                    setActiveSubCategory(item.subcategory[0].id);
                    dispatch(getAllChildCategory(item.subcategory[0].id));
                  } else {
                    // If no subcategories exist, keep showing previous data
                    setActiveSubCategory(null);
                  }
                }}
              >
                {item.name}
              </Nav.Link>
            ))}
          </div>
        </div>
      </section>

      {activeMenu && (
        <div className="main_dropdown_menu_holder">
          <div className="custom_container">
            <div className="dropdown_menu_holder">
              <Tab.Container id="left-tabs-example" activeKey={activeCategory}>
                <div className="row">
                  {/* Left Navigation */}
                  <div className="col-md-3 col-sm-4 col-6">
                    <Nav variant="pills" className="flex-column">
                      {category?.length > 0 ? (
                        category.map((tab) => (
                          <Nav.Item key={tab.id}>
                            <Nav.Link
                              eventKey={tab.id}
                              onClick={(e) => {
                                e.preventDefault();
                                handleCategoryChange(tab.id);
                              }}
                            >
                              {tab.name}
                            </Nav.Link>
                          </Nav.Item>
                        ))
                      ) : (
                        <div className="no-data-message">
                          No categories available
                        </div>
                      )}
                    </Nav>
                  </div>

                  {/* Right Content */}
                  <div className="col-md-9 col-sm-8 col-6">
                    <Tab.Content>
                      {subcategory?.length > 0 ? (
                        subcategory.map((tab) => (
                          <Tab.Pane eventKey={tab.category_id} key={tab.id}>
                            <div className="row">
                              <div className="col-md-6 col-sm-6">
                                <Nav.Link
                                  as={Link}
                                  to={`/visiting-cards?subcategory=${encodeURIComponent(
                                    tab?.name
                                  )}&sub_category_id=${tab?.id}&image=${tab?.image}`}
                                  onClick={() => setActiveMenu(false)}
                                >
                                  {tab?.name}
                                </Nav.Link>
                              </div>
                            </div>
                          </Tab.Pane>
                        ))
                      ) : (
                        <div className="no-data-message text-center">
                          No subcategories available
                        </div>
                      )}
                    </Tab.Content>
                  </div>
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
      )}

      {activeMenuCategory && (
        <div className="main_dropdown_menu_holder">
          <div className="custom_container">
            <div className="dropdown_menu_holder">
              <Tab.Container
                id="left-tabs-example"
                activeKey={activeSubCategory}
              >
                <div className="row">
                  {/* Left Navigation */}
                  <div className="col-md-3 col-sm-4 col-6">
                    <Nav variant="pills" className="flex-column">
                      {subcategory?.length > 0 ? (
                        subcategory.map((tab) => (
                          <Nav.Item key={tab.id}>
                            <Nav.Link
                              eventKey={tab.id}
                              onClick={(e) => {
                                e.preventDefault();
                                handleSubCategoryChange(tab.id);
                              }}
                            >
                              {tab?.name}
                            </Nav.Link>
                          </Nav.Item>
                        ))
                      ) : (
                        <div className="no-data-message">
                          No subcategories available
                        </div>
                      )}
                    </Nav>
                  </div>

                  {/* Right Content */}
                  <div className="col-md-9 col-sm-8 col-6">
                    <Tab.Content>
                      {childcategory?.length > 0 ? (
                        childcategory.map((tab) => (
                          <Tab.Pane eventKey={tab.id} key={tab.id}>
                            <div className="row">
                              <div className="col-md-6 col-sm-6">
                                <Nav.Link
                                  as={Link}
                                  to={`/visiting-cards?childcategory=${encodeURIComponent(
                                    tab?.name
                                  )}&child_category_id=${tab?.id}&image=${tab?.image}`}
                                  onClick={() => setActiveMenuCategory(false)}
                                >
                                  {tab?.name}
                                </Nav.Link>
                              </div>
                            </div>
                          </Tab.Pane>
                        ))
                      ) : (
                        <div className="no-data-message text-center">
                          No data available
                        </div>
                      )}
                    </Tab.Content>
                  </div>
                </div>
              </Tab.Container>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Menu_bar_header;
